"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var prop_types_1 = __importDefault(require("prop-types"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var Portal = function Portal(_a) {
  var targetID = _a.targetID,
    children = _a.children;
  var rootElemRef = react_1.default.useRef(document.getElementById(targetID) || document.createElement('div'));
  var _b = react_1.default.useState(false),
    isMounted = _b[0],
    setIsMounted = _b[1];
  var portalElem = react_1.default.useState(!rootElemRef.current.parentElement)[0];
  react_1.default.useEffect(function () {
    if (portalElem) {
      targetID ? rootElemRef.current.id = targetID : null;
      rootElemRef.current.className += " " + vdl_prefix_1.vdlPrefix('portal-target');
      document.body.appendChild(rootElemRef.current);
    }
    setIsMounted(true);
    return function () {
      rootElemRef.current.parentElement.removeChild(rootElemRef.current);
      setIsMounted(false);
    };
  }, [targetID]);
  return isMounted ? react_dom_1.default.createPortal(children, rootElemRef.current) : null;
};
exports.Portal = Portal;
exports.Portal.propTypes = {
  targetID: prop_types_1.default.string,
  children: prop_types_1.default.any.isRequired,
  autoFocus: prop_types_1.default.bool,
  returnFocus: prop_types_1.default.bool
};